module.exports = __webpack_public_path__ + "static/img/laptop-to-use.b130ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/laptop-to-use.png
// module id = aCdC
// module chunks = 1